<template>
  <div>
    <v-carousel
      :show-arrows="false"
      delimiter-icon="mdi-square"
      hide-delimiters
      light
      :height="heightCarousel"
      deli
      hide-delimiter-background
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <div
          class="Text-Hero"
          v-bind:style="{
            'font-size': fontBanner,
            'margin-left': marginLeft,
            width: width,
            'margin-top': marginTop,
          }"
        >
          <p>Berdayakan UMKM Untuk Memajukan Indonesia</p>
          <p class="Sub-Hero">
            UMKM menyerap 97% tenaga kerja nasional. Bersama Dompet Kilat
            wujudkan UMKM yang kuat.
          </p>
          <v-img
            class="gplay"
            :src="require('../../assets/homepage/Button.svg')"
            @click="note = true"
          />
          <v-dialog
            transition="dialog-bottom-transition"
            v-model="note"
            max-width="550"
          >
            <v-card>
              <v-card-title class="white--text popupTitle">
                Download Aplikasi Dompetkilat
              </v-card-title>
              <v-card-text>
                <div class="text-h6 black--text px-2 mt-6">
                  Anda akan mengunduh aplikasi DompetKilat, Pastikan anda
                  <span class="red--text font-weight-bold"
                    >sudah memiliki kode akses</span
                  >
                </div>
                <div class="text-h6 px-2 mt-6">
                  Masukkan kode akses untuk melanjutkan

                  <v-text-field
                    class="mt-2"
                    v-model="noteCode"
                    label="Kode Akses"
                    color="#D3352C"
                    outlined
                    dense
                    required
                  ></v-text-field>
                  <strong
                    v-if="noteError"
                    class="text-body-1 red--text text--lighten-1"
                    >Kode Akses Salah !!</strong
                  >
                </div>
              </v-card-text>
              <v-divider class="mx-4" />
              <v-card-actions class="justify-end">
                <div class="pb-2">
                  <v-btn
                    class="white--text text-none"
                    color="#D3352C"
                    min-width="125"
                    rounded
                    @click="closeNote"
                    >Batal</v-btn
                  >
                  <v-btn
                    class="ml-4 text-none"
                    min-width="125"
                    outlined
                    color="black"
                    rounded
                    @click="toDownload"
                    >Selanjutnya</v-btn
                  >
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <div
            class="Sub-Hero pt-1 font-weight-light red--text text--darken-2 font-italic"
          >
            *catatan: untuk saat ini, layanan kami hanya dapat digunakan oleh
            yang memiliki kode akses
          </div>
        </div>

        <img src="../../assets/homepage/Hero.svg" class="Hero" />
      </v-carousel-item>
    </v-carousel>
    <div id="stats">
      <v-row class="parameter" justify="center">
        <v-col class="container-stats">
          <p class="title-stats">Pinjaman Tersalurkan</p>
          <p v-if="masterData.pinjaman_tersalurkan" class="stats">
            Rp {{ convertNumber(masterData.pinjaman_tersalurkan) }}
          </p>
          <p v-else class="stats">Rp.119 Miliar</p>
        </v-col>
        <v-col class="container-stats">
          <p class="title-stats">Pinjaman Lunas</p>
          <p v-if="masterData.pinjaman_lunas" class="stats">
            Rp {{ convertNumber(masterData.pinjaman_lunas) }}
          </p>
          <p v-else class="stats">Rp.100 Miliar</p>
        </v-col>
        <v-col class="container-stats">
          <p class="title-stats">Total Oustanding</p>
          <p v-if="masterData.total_outstanding" class="stats">
            Rp {{ convertNumber(masterData.total_outstanding) }}
          </p>
          <p v-else class="stats">Rp.44 Miliar</p>
        </v-col>
        <v-col class="container-stats">
          <p class="title-stats">Total Peminjam</p>
          <p v-if="masterData.total_peminjam" class="stats">
            {{ peminjamNumber(masterData.total_peminjam) }}+
          </p>
          <p v-else class="stats">10 Ribu+</p>
        </v-col>
      </v-row>
    </div>
    <v-container fluid style="background-color: white">
      <v-layout align-center column>
        <!-- <v-row
          v-if="widthNow >= 1600"
          class="mt-8"
          v-bind:style="{
            backgroundColor: '#d3352c',
            borderRadius: '24px',
          }"
          justify="space-between"
        >
          <div
            class="fill-height text-wrap"
            v-bind:style="{
              marginLeft: '50px',
              marginTop: '40px',
              maxWidth: '600px',
              maxHeight: '500px',
            }"
          >
            <div
              class="contentSandbox"
              :style="{
                fontSize: '60px',
              }"
            >
              Sandbox Dompet Kilat
              <img
                contain
                max-height="40px"
                :src="require(`../../assets/homepage/sandbox-flair.svg`)"
              />
            </div>
            <div
              class="contentSandboxSub pt-4"
              :style="{
                fontSize: '25px',
              }"
            >
              Telusuri fitur API kami dan temukan beragam contoh response tanpa
              harus membuat satupun codingan
            </div>

            <v-btn
              rounded
              color="white"
              class="red--text text-none px-14 py-8 mt-6"
              @click="toSandbox"
              elevation="0"
            >
              <div
                class="contentSandboxButton"
                :style="{
                  fontSize: '25px',
                }"
              >
                Coba Sekarang
              </div>
              <v-icon right dark>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-img
            class="pr-12"
            contain
            max-height="500px"
            :src="require(`../../assets/homepage/sandbox-2.svg`)"
          ></v-img>
        </v-row> -->
        <!-- <v-row
          v-if="widthNow <= 1600 && widthNow >= 1065"
          class="mt-8"
          v-bind:style="{
            backgroundColor: '#d3352c',
            borderRadius: '24px',
          }"
          justify="space-between"
        >
          <div
            class="fill-height text-wrap"
            v-bind:style="{
              marginLeft: '40px',
              marginTop: '20px',
              maxWidth: '400px',
              maxHeight: '500px',
            }"
          >
            <div
              class="contentSandbox"
              :style="{
                fontSize: '40px',
              }"
            >
              Sandbox Dompet Kilat
              <img
                contain
                height="30px"
                :src="require(`../../assets/homepage/sandbox-flair.svg`)"
              />
            </div>
            <div
              class="contentSandboxSub pt-4"
              :style="{
                fontSize: '15px',
              }"
            >
              Telusuri fitur API kami dan temukan beragam contoh response tanpa
              harus membuat satupun codingan
            </div>

            <v-btn
              rounded
              color="white"
              class="red--text text-none px-8 py-4 mt-6"
              @click="toSandbox"
              elevation="0"
            >
              <div
                class="contentSandboxButton"
                :style="{
                  fontSize: '15px',
                }"
              >
                Coba Sekarang
              </div>
              <v-icon right dark>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-img
            class="pr-12"
            contain
            max-height="500px"
            max-width="600px"
            :src="require(`../../assets/homepage/sandbox-2.svg`)"
          ></v-img>
        </v-row> -->
        <!-- <v-row
          v-if="widthNow <= 1065"
          class="mt-8"
          v-bind:style="{
            backgroundColor: '#d3352c',
            borderRadius: '24px',
          }"
          justify="space-between"
        >
          <div
            class="fill-height text-wrap"
            v-bind:style="{
              marginLeft: '40px',
              marginTop: '20px',
              maxWidth: '300px',
              maxHeight: '500px',
            }"
          >
            <div
              class="contentSandbox"
              :style="{
                fontSize: '30px',
              }"
            >
              Sandbox Dompet Kilat
              <img
                contain
                height="30px"
                :src="require(`../../assets/homepage/sandbox-flair.svg`)"
              />
            </div>
            <div
              class="contentSandboxSub pt-4"
              :style="{
                fontSize: '10px',
              }"
            >
              Telusuri fitur API kami dan temukan beragam contoh response tanpa
              harus membuat satupun codingan
            </div>

            <v-btn
              rounded
              color="white"
              class="red--text text-none px-4 my-4"
              @click="toSandbox"
              elevation="0"
            >
              <div
                class="contentSandboxButton"
                :style="{
                  fontSize: '10px',
                }"
              >
                Coba Sekarang
              </div>
              <v-icon right dark>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-img
            class="pr-12"
            contain
            max-height="500px"
            max-width="300px"
            :src="require(`../../assets/homepage/sandbox-2.svg`)"
          ></v-img>
        </v-row> -->
        <v-flex align-center d-flex fluid style="margin-top: 100px">
          <span
            class="Credit-Checker"
            style="
              margin-top: 20px;
              margin-bottom: 60px;
              display: inline-block;
              font-size: 26.7px;
              color: #252525;
            "
            >Mengapa Dompet Kilat</span
          >
        </v-flex>
        <v-row align="center" justify="center" style="max-width: 1000px">
          <v-col v-for="(slide, i) in slides" :key="i">
            <v-row align="center" justify="center">
              <v-col>
                <v-skeleton-loader
                  height="80"
                  type="image"
                  v-if="!isWhyLoaded"
                ></v-skeleton-loader>
                <v-img
                  class="mx-auto"
                  style="width: 80px; height: 80px"
                  @load="onWhyImgLoad"
                  :src="require(`../../assets/homepage/${slide.icon}`)"
                >
                  <!-- <v-card-title  style="font-size: 10px; margin-bottom:-28px"></v-card-title> -->
                </v-img>
              </v-col>
              <v-col>
                <p class="title-kenapa">{{ slide.title }}</p>
                <p class="content-kenapa">{{ slide.content }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-flex align-center d-flex fluid style="margin-top: 100px">
          <span
            class="Credit-Checker"
            style="
              margin-top: 20px;
              margin-bottom: 60px;
              display: inline-block;
              font-size: 26.7px;
              color: #252525;
            "
            >Produk Yang Tersedia</span
          >
        </v-flex>

        <v-row>
          <v-card class="mx-4 my-2" max-width="400" elevation="0" outlined>
            <v-img
              class="white--text align-end"
              contain
              src="../../assets/homepage/agri_image.png"
            >
            </v-img>

            <div class="pa-4">
              <v-img width="80" src="../../assets/homepage/agri_logo.png">
              </v-img>
              <div class="pt-4 font-weight-medium">
                Wujudkan ketahanan pangan Indonesia dengan menanam dana, nikmati
                hasil panen bersama petani & peternak.
              </div>

              <v-divider />

              <div style="color: #3bb54a">Syarat & Ketentuan</div>

              <div class="pt-4">
                Persyaratan yang harus dipenuhi untuk dapat mengajukan pinjaman
                melalui Dompet Kilat antara lain:
              </div>

              <div class="pt-4 pb-12">
                Menyerahkan persyaratan administratif seperti: KTP, Kartu
                Keluarga NPWP, Surat Keterangan Usaha dan lain-lain Memiliki
                usaha ternak / tani lebih dari setahun Tergabung dalam kelompok
                tani / ternak binaan
              </div>

              <v-btn
                color="white"
                rounded
                block
                @click="$router.push('/pinjaman')"
                ><span
                  class="text-none font-weight-bold"
                  style="color: #3bb54a; margin: 0"
                >
                  Pelajari Lebih Lanjut
                </span>
                <v-icon right dark color="#3bb54a">
                  mdi-chevron-right
                </v-icon></v-btn
              >
            </div>

            <div class="font-weight-medium" style="background: #3bb54a">
              <span style="visibility: hidden">Lorem ipsum</span>
            </div>
          </v-card>

          <v-card class="mx-4 my-2" max-width="400" elevation="0" outlined>
            <v-img
              class="white--text align-end"
              contain
              src="../../assets/homepage/modal_image.png"
            >
            </v-img>

            <div class="pa-4">
              <v-img width="90" src="../../assets/homepage/modal_logo.png">
              </v-img>
              <div class="pt-4 font-weight-medium">
                Lakukan penanaman modal untuk usaha potensial, dapatkan
                keuntungan finansial yang menarik.
              </div>

              <v-divider />

              <div style="color: #efaf0b">Syarat & Ketentuan</div>

              <div class="pt-4">
                Persyaratan yang harus dipenuhi untuk dapat mengajukan pinjaman
                melalui Dompet Kilat antara lain:
              </div>

              <div class="pt-4 pb-14">
                Menyerahkan persyaratan administratif seperti: KTP, Akta
                pendirian usaha, SIUP, SITU, TDP dan lain sebagainya Memberikan
                copy cashflow perusahaan dan AMDAL (apabila ada) Menyertakan
                invoice berupa nominal pembiayaan pada Dompet Kilat yang sesuai
                dengan kebutuhan
              </div>

              <v-btn
                color="white"
                rounded
                block
                @click="$router.push('/pinjaman')"
                ><span
                  class="text-none font-weight-bold"
                  style="color: #efaf0b; margin: 0"
                >
                  Pelajari Lebih Lanjut
                </span>
                <v-icon right dark color="#EFAF0B">
                  mdi-chevron-right
                </v-icon></v-btn
              >
            </div>

            <div class="font-weight-medium" style="background: #efaf0b">
              <span style="visibility: hidden">Lorem ipsum</span>
            </div>
          </v-card>

          <v-card class="mx-4 my-2" max-width="400" elevation="0" outlined>
            <v-img
              class="white--text align-end"
              contain
              src="../../assets/homepage/gaji_image.png"
            >
            </v-img>

            <div class="pa-4">
              <v-img width="80" src="../../assets/homepage/gaji_logo.png">
              </v-img>
              <div class="pt-4 font-weight-medium">
                Membantu karyawan/pekerja untuk memperoleh gaji lebih cepat,
                serta tumbuhkan uang dengan pasti.
              </div>

              <v-divider />

              <div style="color: #0ce3f1">Syarat & Ketentuan</div>

              <div class="pt-4">
                Persyaratan yang harus dipenuhi untuk dapat mengajukan pinjaman
                melalui Dompet Kilat antara lain:
              </div>

              <div class="pt-4 pb-12">
                Menyerahkan persyaratan administratif seperti: KTP, Kartu
                Keluarga NPWP, Surat Keterangan Usaha dan lain-lain Memiliki
                usaha ternak / tani lebih dari setahun Tergabung dalam kelompok
                tani / ternak binaan
              </div>

              <v-btn
                color="white"
                rounded
                block
                @click="$router.push('/pinjaman')"
                ><span
                  class="text-none font-weight-bold"
                  style="color: #0ce3f1; margin: 0"
                >
                  Pelajari Lebih Lanjut
                </span>
                <v-icon right dark color="#0CE3F1">
                  mdi-chevron-right
                </v-icon></v-btn
              >
            </div>

            <div class="font-weight-medium" style="background: #0ce3f1">
              <span style="visibility: hidden">Lorem ipsum</span>
            </div>
          </v-card>
        </v-row>

        <!-- <v-skeleton-loader
          width="100%"
          type="image"
          v-if="!isProdLoaded"
        ></v-skeleton-loader>
        <v-img
          @load="onProdImgLoad"
          src="../../assets/homepage/produk-placeholder-2.webp"
          class="produkPlaceholder"
        /> -->
        <!-- <v-row v-if="widthNow >= 1200">
          <TittleProduk :category="'agri'" style="max-width: 500px" />
          <Produk v-for="(slide, i) in 3" :key="i" />
        </v-row>
        <div v-if="widthNow <= 1200" :style="{ width: widthNow }">
          <TittleProduk :category="'agri'" :style="{ width: widthNow }" />
          <v-slide-group style="margin-left: 10%; margin-right: 5%;">
            <v-slide-item v-for="(slide, i) in 3" :key="i" class="text-wrap">
              <Produk />
            </v-slide-item>
          </v-slide-group>
        </div>
        <v-row v-if="widthNow >= 1200">
          <TittleProduk :category="'modal'" style="max-width: 500px" />
          <Produk v-for="(slide, i) in 3" :key="i" />
        </v-row>
        <div v-if="widthNow <= 1200" :style="{ width: widthNow }">
          <TittleProduk :category="'modal'" :style="{ width: widthNow }" />
          <v-slide-group style="margin-left: 10%; margin-right: 5%;">
            <v-slide-item v-for="(slide, i) in 3" :key="i" class="text-wrap">
              <Produk />
            </v-slide-item>
          </v-slide-group>
        </div>
        <v-row v-if="widthNow >= 1200">
          <TittleProduk :category="'gaji'" style="max-width: 500px" />
          <Produk v-for="(slide, i) in 3" :key="i" />
        </v-row>
        <div v-if="widthNow <= 1200" :style="{ width: widthNow }">
          <TittleProduk :category="'gaji'" :style="{ width: widthNow }" />
          <v-slide-group style="margin-left: 10%; margin-right: 5%;">
            <v-slide-item v-for="(slide, i) in 3" :key="i" class="text-wrap">
              <Produk />
            </v-slide-item>
          </v-slide-group>
        </div>-->
        <h1 style="margin-top: 100px">Testimonial</h1>
        <v-row
          style="
            width: 331px;
            height: 50px;
            flex-grow: 0;
            margin: 32px 74px 38px 73px;
            padding: 3px 49px 3px 3px;
            border-radius: 25px;
            box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
            background-color: var(--white);
          "
        >
          <!-- typeof objArray != 'object' ? JSON.parse(objArray) : objArray -->
          <v-btn
            @click="testimo('pendana')"
            v-bind:style="{
              borderRadius: this.testiNow == 'pendana' ? 22 + 'px' : '',
              backgroundColor: 'white',
              color: this.testiNow == 'peminjam' ? '#b5b5b5' : '',
              boxShadow: this.testiNow == 'peminjam' ? 'none' : '',
              border: this.testiNow == 'pendana' ? 'solid 2px #d3352c' : '',
            }"
            class="pendana"
            >Pendana</v-btn
          >
          <v-btn
            @click="testimo('peminjam')"
            v-bind:style="{
              borderRadius: this.testiNow == 'peminjam' ? 22 + 'px' : '',
              backgroundColor: 'white',
              color: this.testiNow == 'pendana' ? '#b5b5b5' : '',
              boxShadow: this.testiNow == 'pendana' ? 'none' : '',
              border: this.testiNow == 'peminjam' ? 'solid 2px #d3352c' : '',
            }"
            class="peminjam"
            >Peminjam</v-btn
          >
        </v-row>
        <testimonial
          class="testimonialPeminjam"
          :testi="testi"
          v-if="this.testiNow == 'peminjam' && widthNow >= 1200"
        />
        <testimonial
          class="testimonialPendana"
          :testi="testi"
          v-if="this.testiNow == 'pendana' && widthNow >= 1200"
        />
        <testimonial-mobile
          class="testimonialPeminjam"
          :testi="testi"
          v-if="testiNow == 'peminjam' && widthNow <= 1200"
        />
        <testimonial-mobile
          class="testimonialPendana"
          :testi="testi"
          v-if="testiNow == 'pendana' && widthNow <= 1200"
        />
        <v-row
          v-if="widthNow >= 1300"
          v-bind:style="{
            width: this.widthNow + 'px',
            height: '250px',
            flexGrow: 0,
            margin: '200px 0 0',
            backgroundColor: '#d3352c',
          }"
          justify="center"
        >
          <!-- <v-row style="" justify="center"> -->
          <!-- <PhoneSvg /> -->
          <v-img
            style="margin-top: -191px; margin-right: 25px"
            max-width="325px"
            contain
            :src="require(`./phone.svg`)"
          ></v-img>

          <div
            class="contentPhone fill-height text-wrap"
            v-bind:style="{
              marginLeft: '50px',
              marginTop: '40px',
              fontSize: '44px',
              maxWidth: '900px',
            }"
          >
            Tambah Penghasilanmu dengan Cepat, Tanamkan Modalmu lewat Dompet
            Kilat
            <!-- <v-img
              style="
                width: 208px;
                height: 50px;
                margin-top: 15px;
                margin-left: -23px;
                cursor: pointer;
              "
              :src="require(`../../assets/homepage/googleplay.png`)"
              @click="toPlayStore"
            >
            </v-img>-->
          </div>

          <!-- > -->
        </v-row>
        <v-row v-if="widthNow <= 1300">
          <div class="Shape2">
            <!-- <v-row style="" justify="center"> -->
            <!-- <PhoneSvg /> -->

            <div class="contentPhone2 fill-height text-wrap">
              Tambah Penghasilanmu dengan Cepat, Tanamkan Modalmu lewat Dompet
              Kilat
              <!-- <v-img
                class="Shape2GPlayImage"
                max-width="268px"
                contain
                :src="require(`../../assets/homepage/googleplay.png`)"
              >
              </v-img>-->

              <v-img
                class="Shape2PhoneImage"
                max-width="325px"
                contain
                :src="require(`./phone.webp`)"
              ></v-img>
            </div>

            <!-- > -->
          </div>
        </v-row>
        <div>
          <h1 style="margin-top: 100px">Daftar Mitra</h1>
        </div>
        <v-row align="center" justify="center" style="max-width: 1300px">
          <v-col
            v-for="image in mirtas"
            :key="image"
            style="
              max-width: 209px;
              height: 130px;
              margin: 20px;
              border-radius: 8px;
              border: solid 1px #f1f1f1;
              background-color: #ffffff;
            "
          >
            <v-skeleton-loader
              height="100%"
              width="209"
              type="image"
              v-if="!isMitraLoaded"
            ></v-skeleton-loader>
            <v-img
              style="width: 109px; margin-left: 5px; height: 100%"
              contain
              @load="onMitraImgLoad"
              v-bind:src="image"
            >
              <!-- <v-card-title  style="font-size: 10px; margin-bottom:-28px"></v-card-title> -->
            </v-img>
          </v-col>
        </v-row>

        <!-- </v-row> -->
      </v-layout>
    </v-container>

    <!-- <v-row v-resize="onResize" align="center" justify="center">
      <v-subheader>Window Size</v-subheader>
      {{ windowSize }}
    </v-row>-->
  </div>
</template>

<script>
// import instance from "../myconfig";
// import Swal from "sweetalert2"
// import TittleProduk from "../Produk/TittleProduk";
import Testimonial from "../pinjaman/Testimonial";
import axios from "axios";
import TestimonialMobile from "../pinjaman/TestimonialMobile";
// import Produk from "../Produk/Produk";
// import PhoneSvg from "./PhoneSvg";
export default {
  name: "HelloWorld",
  components: {
    Testimonial,
    TestimonialMobile,
  },

  mounted() {
    this.onResize();
    this.testi = this.testiPendana;
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  created() {
    console.log(window.innerWidth);
    if (window.innerWidth <= 550) {
      this.fontSize = "20px";
    } else if (window.innerWidth <= 1600) {
      this.fontSize = "20px";
    } else {
      this.fontSize = "20px";
    }

    window.addEventListener("resize", this.myEventHandler);
  },
  computed: {
    button() {
      // var height = window.innerHeight;
      // var tambah = 0;
      // while (height !== 212) {
      //   height = height - tambah;
      //   tambah++;
      // }
      let y = window.innerHeight;
      let i = 1;
      let layar = (window.innerHeight * 7) / 8;
      while (y > layar) {
        y--;
        i++;
        //
        //
        // y -= i
        // y = 500
        // i++
      }
      return i;
    },
    masterData() {
      return this.$store.state.masterData;
    },
  },
  methods: {
    convertNumber(num) {
      if (num > 999 && num < 1000000) {
        return (num / 1000).toFixed() + " Ribu";
      } else if (num > 1000000 && num < 1000000000) {
        return (num / 1000000).toFixed() + " Juta";
      } else if (num > 1000000000 && num < 1000000000000) {
        return (num / 1000000000).toFixed() + " Miliar";
      } else if (num > 1000000000000) {
        return (num / 1000000000000).toFixed() + " Triliun";
      } else if (num < 900) {
        return num;
      }
    },
    toPlayStore() {
      window.location =
        "https://play.google.com/store/apps/details?id=com.dompetkilat&hl=in&gl=US";
    },
    forceFileDownload(response) {
      window.open(response.data.data.url);
    },
    download(url) {
      axios({
        method: "get",
        url,
      })
        .then((response) => {
          this.forceFileDownload(response);
        })
        .catch(() => console.log("error occured"));
    },
    toDownload() {
      if (this.noteCode === "3k0s1stemDK") {
        this.download("https://dompetkilat.co.id/apks/dompetkilat.apk");
        this.noteCode = "";
        this.note = false;
        this.noteError = false;
      } else {
        this.noteError = true;
      }
    },
    toSandbox() {
      window.location.href = "https://partner.dompetkilat.id/";
    },
    closeNote() {
      this.note = false;
      this.noteCode = "";
      this.noteError = false;
    },
    onProdImgLoad() {
      this.isProdLoaded = true;
    },
    onWhyImgLoad() {
      this.isWhyLoaded = true;
    },
    onTestiImgLoad() {
      this.isTestiLoaded = true;
    },
    onGplayImgLoad() {
      this.isGplayLoaded = true;
    },
    onMitraImgLoad() {
      this.isMitraLoaded = true;
    },
    peminjamNumber(num) {
      if (num > 999 && num < 1000000) {
        return (num / 1000).toFixed(0) + " Ribu";
      } else if (num > 1000000 && num < 1000000000) {
        return (num / 1000000).toFixed(1) + " Juta";
      } else if (num > 1000000000 && num < 1000000000000) {
        return (num / 1000000000).toFixed(1) + " Miliar";
      } else if (num > 1000000000000) {
        return (num / 1000000000000).toFixed(1) + " Triliun";
      } else if (num < 900) {
        return num;
      }
    },

    testimo(payload) {
      this.testiNow = payload;
      if (this.testiNow == "pendana") {
        this.testi = this.testiPendana;
      } else {
        this.testi = this.testiPeminjam;
      }
    },
    scroll() {
      document
        .querySelector("#formulir")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    },
    myEventHandler() {
      // console.log(e)
      console.log(window.innerWidth);

      if (window.innerWidth <= 550) {
        this.fontSize = "20px";
      } else if (window.innerWidth <= 2023) {
        this.fontSize = "20px";
      } else {
        this.fontSize = "32px";
      }
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTop = `${window.innerWidth / 7}px`;
      this.width = `${window.innerWidth / 3}px`;
      this.fontBanner = `${window.innerWidth / 40}px`;
      this.leftContent = window.innerWidth / 13;
      this.widthSize = window.innerWidth - 100;
      this.widthDaftar = window.innerWidth / 8;
      this.fontDaftar = window.innerHeight / 45;
      this.heightDaftar = window.innerHeight / 20;
      this.widthNow = window.innerWidth;
      this.marginDaftar = window.innerWidth / 40;
      this.heightNow = window.innerHeight;
      this.buttonWidth = window.innerWidth / 12.4;
      this.imageWidth = window.innerWidth / 5.4;
      this.heightCarousel = window.innerWidth / 2.75 + "px";
      this.marginLeftWordBanner = window.innerWidth / 8;

      // your code for handling resize...
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    cek() {
      this.$store.commit("NEXT", "biodata");
    },
  },
  data: () => ({
    testiNow: "pendana",
    testi: [],
    testiPendana: [
      {
        name: "Garry",
        job: "Head of Investment PT Sinar Mas Ventura",
        desc: `Dompet Kilat menyediakan platform P2P yang sangat membantu kita dalam penyaluran pembiayaan untuk usaha produktif. Selain mendapatkan keuntungan yang menarik, kami juga mendapatkan kepuasan karena bisa membantu UMKM untuk berkembang.`,
        img: require("../../assets/pinjaman/user/image_testi_lender_1.png"),
      },
      {
        name: "Tabrani",
        job: "Petani",
        desc: `Dompet Kilat bekerjasama dengan beberapa pihak diantaranya PT. Bayer, Indo Buana Berkah & asuransi yang dapat mendampingi kami para petani agar mendapatkan hasil yang maksimal. Terima kasih Dompet Kilat!
`,
        img: "",
      },
      {
        name: "Muhammad Chandra ",
        job: "Security",
        desc: `Program pembiayaan seragam dari Dompet Kilat sangat membantu saya agar dapat bekerja menggunakan seragam security yang telah ditentukan oleh perusahaan. Prosesnya gampang dan cepat! Terima kasih Dompet Kilat.
`,
        img: "",
      },
      {
        name: "Wiyudo",
        job: "Tambak Udang",
        desc: `Selama 3 tahun bekerja sama dengan Dompet Kilat, saya sangat terbantu karena kita bisa mengajukan pinjaman tanpa agunan. Dompet Kilat juga menyediakan ekosistem pendanaan yang sangat membantu dalam penyediaan kebutuhan. Terima kasih Dompet Kilat!`,
        img: "",
      },
    ],
    testiPeminjam: [
      {
        name: "Ario",
        job: "Petambak Udang",
        desc: `Selama saya mendapatkan bantuan pinjaman dari Dompet Kilat, saya sangat terbantu, terutama dari sisi finansial. Memang masih ada beberapa kekurangan dalam sistem Dompet Kilat dan termasuk saya juga tentunya, namun anggotanya sangat open minded dan terbuka untuk bekerja mencari solusi sehingga beberapa kendala dapat diatasi bersama. Maju terus Dompet Kilat!!`,
        img: require("../../assets/pinjaman/user/image_testi_borrower_1.png"),
      },
      {
        name: "Mugiyo",
        job: "Petani",
        desc: `Saya sangat bersyukur bisa bekerja sama dengan Dompet Kilat. Pinjaman finansial tentunya sangat membantu usaha saya, tapi yang lebih bermanfaat adalah ekosistem yang dibangun oleh Dompet Kilat. Usaha saya berkembang pesat setelah bekerja sama dengan Dompet Kilat. Terima Kasih!`,
        img: require("../../assets/pinjaman/user/image_testi_borrower_2.png"),
      },
      {
        name: "Wiyudo",
        job: "Tambak Udang",
        desc: `Selama 3 tahun bekerja sama dengan Dompet Kilat, saya sangat terbantu karena kita bisa mengajukan pinjaman tanpa agunan. Dompet Kilat juga menyediakan ekosistem pendanaan yang sangat membantu dalam penyediaan kebutuhan. Terima kasih Dompet Kilat!`,
        img: "",
      },
      {
        name: "Muhammad Chandra ",
        job: "Security",
        desc: `Program pembiayaan seragam dari Dompet Kilat sangat membantu saya agar dapat bekerja menggunakan seragam security yang telah ditentukan oleh perusahaan. Prosesnya gampang dan cepat! Terima kasih Dompet Kilat.
`,
        img: "",
      },
      {
        name: "Tabrani",
        job: "Petani",
        desc: `Dompet Kilat bekerjasama dengan beberapa pihak diantaranya PT. Bayer, Indo Buana Berkah & asuransi yang dapat mendampingi kami para petani agar mendapatkan hasil yang maksimal. Terima kasih Dompet Kilat!
`,
        img: "",
      },
    ],
    mirtas: [
      require("../../assets/homepage/asosiasi/sum.png"),
      require("../../assets/homepage/asosiasi/logo-BNI-46-1.png"),
      require("../../assets/homepage/asosiasi/kargo.png"),
      require("../../assets/homepage/jala.jpg"),
      require("../../assets/homepage/asosiasi/Logo-GrosirOne-2.png"),
      require("../../assets/homepage/asosiasi/TF-Logo-horizontal-OK.png"),
      require("../../assets/homepage/asosiasi/pefindo-logo.svg"),
      require("../../assets/homepage/asosiasi/bri.png"),
      require("../../assets/homepage/asosiasi/bca.png"),
      require("../../assets/homepage/asosiasi/digisign.jpg"),
      require("../../assets/homepage/asosiasi/faspay.png"),
      require("../../assets/homepage/asosiasi/logo_bank_sinarmas.png"),
      require("../../assets/homepage/asosiasi/SIRCLO.png"),
      require("../../assets/homepage/asosiasi/sos.png"),
      require("../../assets/homepage/asosiasi/pinhome.png"),
      require("../../assets/homepage/asosiasi/venteny.jpeg"),
      require("../../assets/homepage/asosiasi/gocement.png"),
      require("../../assets/homepage/asosiasi/instamoney.jpeg"),
      require("../../assets/homepage/asosiasi/idx.svg"),
      require("../../assets/homepage/asosiasi/tekenaja.webp"),
      require("../../assets/homepage/asosiasi/asliri.jpeg"),
    ],
    slides: [
      {
        title: "Mudah",
        content:
          "Proses pendanaan dan peminjaman secara online secara sederhana dan mudah dipahami",
        icon: "Mudah.png",
      },
      {
        title: "Cerdas",
        content:
          "Risiko terukur dengan menggunakan teknologi terbaru untuk menganalisis risiko",
        icon: "Cerdas.png",
      },
      {
        title: "Aman",
        content:
          "Mengantongi izin usaha resmi dan diawasi langsung oleh OJK (KEP-47/D.05/2019)",
        icon: "aman.png",
      },
      {
        title: "Keuntungan Menarik",
        content:
          "Dapatkan imbal hasil hingga 20% per tahun. Lebih tinggi dari produk investasi pada umumnya",
        icon: "keuntungan.png",
      },
      {
        title: "Dampak Sosial",
        content:
          "Membantu UMKM untuk mengembangkan usahanya dan mendorong pertumbuhan ekonomi nasional",
        icon: "sosial.png",
      },
      {
        title: "Tepercaya",
        content:
          "Menggunakan sistem pengelolaan risiko yang terintegrasi dan transparan dengan jaminan asuransi",
        icon: "terpercaya.png",
      },
    ],
    buttonWidth: window.innerWidth / 12.4,
    heightNow: window.innerHeight,
    leftContent: window.innerWidth / 13,
    widthNow: window.innerWidth,
    fontBanner: `${window.innerWidth / 40}px`,
    marginLeft: `${window.innerWidth / 8}px`,
    marginTop: `${window.innerWidth / 15}px`,
    width: `${window.innerWidth / 4}px`,
    marginDaftar: window.innerWidth / 40,
    fontDaftar: window.innerHeight / 45,
    widthDaftar: window.innerWidth / 8,
    heightDaftar: window.innerHeight / 20,
    imageWidth: window.innerWidth / 5.4,
    heightCarousel: window.innerWidth / 2.75 + "px",
    marginLeftWordBanner: window.innerWidth / 8,
    fontSize: "32px",
    widthSize: window.innerWidth - 100,
    amount: 0,
    showStepper: false,
    phone: "",
    nik: "",
    email: "",
    gaji: 0,
    windowSize: {
      x: 0,
      y: 0,
    },
    isProdLoaded: false,
    isWhyLoaded: false,
    isTestiLoaded: false,
    isGplayLoaded: false,
    isMitraLoaded: false,
    note: false,
    noteCode: "",
    noteError: false,
  }),
};
</script>
<style scoped>
.Text-Hero {
  width: 590px;
  margin: 137px 810px 0 200px;
  font-family: Sora;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  position: absolute;
}
.contentPhone {
  height: 300px;
  flex-grow: 0;
  font-family: Inter;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: white;
}
.contentSandbox {
  flex-grow: 0;
  font-family: Inter;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: white;
}
.contentSandboxSub {
  flex-grow: 0;
  font-family: Inter;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: white;
}
.contentSandboxButton {
  flex-grow: 0;
  font-family: Inter;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
}
.testimonialPeminjam {
  animation: slide 2s forwards;
  position: relative;
}
.testimonialPendana {
  animation: pendana 2s forwards;
  position: relative;
}
.pendana {
  width: 160px;
  height: 44px;
  flex-grow: 0;
  margin: 0 51px 0 0;
  padding: 13px 50px 14px;
}
.Hero {
  width: 100%;
  object-fit: contain;
}
.peminjam {
  width: 160px;
  height: 44px;
  flex-grow: 0;
  margin-right: -200px;
  margin-left: -50px;
  padding: 13px 50px 14px;
}

.Section-Titlea {
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.title-kenapa {
  flex-grow: 0;
  font-family: Sora;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.content-kenapa {
  width: 285px;
  height: 66px;
  flex-grow: 0;
  margin: 10px 10px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.rekomendasi {
  width: 278px;
  height: 31px;
  font-family: sora;
  font-size: 23px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.35;
  letter-spacing: -0.46px;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.Sub-Hero {
  font-size: 15px;
  margin-bottom: 10px;
}
.gplay {
  width: 280px;
  height: 85px;
  flex-grow: 0;
  margin-left: -25px;
  cursor: pointer;
}
#stats .parameter {
  width: 1200px;
  height: 120px;
  flex-grow: 0;
  position: relative;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  padding-top: 1%;
  border-radius: 12px;
  box-shadow: 0 18px 30px 0 rgba(225, 225, 225, 0.15);
  background-color: #ffffff;
}
#stats .container-stats {
  max-width: 220px;
  max-height: 63px;
  flex-grow: 0;
  margin: 0 60px 0 0;
}
#stats .title-stats {
  width: 220px;
  height: 22px;
  flex-grow: 0;
  margin: 0 0 6px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.69;
  letter-spacing: normal;
  text-align: center;
  color: #b5b5b5;
}
#stats .stats {
  width: 220px;
  height: 35px;
  flex-grow: 0;
  margin: 6px 0 0;
  font-family: Sora;
  font-size: 28px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.produkPlaceholder {
  max-height: 380px;
  left: 0;
  right: 0;
}
.popupTitle {
  background-color: #d3352c;
}
@media screen and (max-width: 1342px) {
  .Sub-Hero {
    font-size: 13px;
    margin-bottom: 0px;
  }
  .gplay {
    width: 196px;
    height: 44px;
    flex-grow: 0;
    margin-top: 10px;
    margin-left: -15px;
    margin-bottom: 10px;
    object-fit: contain;
  }
  #stats .parameter {
    max-width: 1000px;
    max-height: 120px;
    flex-grow: 0;
    position: relative;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 12px;
    box-shadow: 0 18px 30px 0 rgba(225, 225, 225, 0.15);
    background-color: #ffffff;
  }
  #stats .container-stats {
    max-width: 180px;
    max-height: 53px;
    flex-grow: 0;
    margin: 0 40px 0 0;
  }
  #stats .title-stats {
    width: 180px;
    height: 22px;
    flex-grow: 0;
    margin: 0 0 6px;
    font-family: Inter;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.69;
    letter-spacing: normal;
    text-align: center;
    color: #b5b5b5;
  }
  #stats .stats {
    width: 180px;
    height: 27px;
    flex-grow: 0;
    margin: 6px 0 0;
    left: 0;
    right: 0;
    font-family: Sora;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
}
@media screen and (max-width: 1042px) {
  .Sub-Hero {
    font-size: 11px;
    margin-bottom: -10px;
  }
  .gplay {
    width: 176px;
    height: 44px;
    flex-grow: 0;
    margin-top: 10px;
    margin-left: -15px;
    margin-bottom: 10px;
    object-fit: contain;
  }
  #stats .parameter {
    max-width: 800px;
    max-height: 100px;
    flex-grow: 0;
    position: relative;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 12px;
    box-shadow: 0 18px 30px 0 rgba(225, 225, 225, 0.15);
    background-color: #ffffff;
  }
  #stats .container-stats {
    max-width: 140px;
    max-height: 43px;
    flex-grow: 0;
    margin: 0 40px 0 0;
  }
  #stats .title-stats {
    width: 140px;
    height: 20px;
    flex-grow: 0;
    margin: 0 0 6px;
    font-family: Inter;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.69;
    letter-spacing: normal;
    text-align: center;
    color: #b5b5b5;
  }
  #stats .stats {
    width: 140px;
    height: 22px;
    flex-grow: 0;
    margin: 6px 0 0;
    left: 0;
    right: 0;
    font-family: Sora;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
}
@media screen and (max-width: 842px) {
  .Sub-Hero {
    font-size: 9px;
    margin-bottom: -20px;
  }
  .gplay {
    width: 156px;
    height: 44px;
    flex-grow: 0;
    object-fit: contain;
  }
  .content-kenapa {
    width: 285px;
    height: 66px;
    flex-grow: 0;
    margin: 10px 46px 0;
    font-family: Inter;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
  #stats .parameter {
    max-width: 600px;
    max-height: 60px;
    flex-grow: 0;
    position: relative;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 12px;
    box-shadow: 0 18px 30px 0 rgba(225, 225, 225, 0.15);
    background-color: #ffffff;
  }
  #stats .container-stats {
    max-width: 120px;
    max-height: 33px;
    flex-grow: 0;
    margin: 0 10px 0 0;
  }
  #stats .title-stats {
    width: 120px;
    height: 12px;
    flex-grow: 0;
    margin: 0 0 6px;
    font-family: Inter;
    font-size: 8px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.69;
    letter-spacing: normal;
    text-align: center;
    color: #b5b5b5;
  }
  #stats .stats {
    width: 120px;
    height: 17px;
    flex-grow: 0;
    margin: 6px 0 0;
    left: 0;
    right: 0;
    font-family: Sora;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
}
.akurat {
  width: 239px;
  height: 31px;
  font-family: sora;
  font-size: 23px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.35;
  letter-spacing: -0.46px;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.text-desc {
  width: 279px;
  height: 70px;
  font-family: sora;
  font-size: 15px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.3px;
  text-align: left;
  color: #4a4a4a;
}
.mengapa-logo {
  width: 208.1px;
  height: 173.1px;
  margin-right: 23px;
  object-fit: contain;
}
.logo-keamanan {
  width: 199px;
  height: 173.3px;
  object-fit: contain;
}
.keamanan {
  width: 279px;
  height: 31px;
  font-family: sora;
  font-size: 23px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.35;
  letter-spacing: -0.46px;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.mengapa-creditable {
  width: 303px;
  height: 37px;
  font-family: sora;
  font-size: 26.7px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: -0.53px;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.rectangle {
  width: 156px;
  height: 154px;
  border-radius: 15px;
  box-shadow: 0 10px 14px 0 rgba(239, 132, 117, 0.3);
}
.logo-finansial {
  width: 70.4px;
  height: 70.4px;
}
.text-finansial {
  width: 103px;
  height: 20px;
  font-family: sora;
  font-size: 15px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.3px;
  text-align: left;
  color: #ffffff;
}
.card-header {
  border-color: white !important;
}
.desc-finansial {
  width: 112px;
  height: 37px;
  font-family: sora;
  font-size: 9px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.18px;
  text-align: center;
  color: #ffffff;
}
.Credit-Checker {
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.37;
  letter-spacing: -1.2px;
  text-align: center;
  color: #ffffff;
}
.Cepat-Akurat-Aman {
  font-size: 25px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: -0.5px;
  text-align: left;
  color: #ffffff;
}
.analisis {
  width: 289.4px;
  height: 206.3px;
  object-fit: contain;
}
.Cek-Sekarang {
  font-family: sora;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.4px;
  text-align: left;
  color: #ffffff;
}
.Untuk-apa-credit-score {
  width: 289px;
  height: 37px;
  font-family: sora;
  font-size: 26.7px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: -0.53px;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.contentPhone2 {
  height: 120px;
  flex-grow: 0;
  padding-top: 3%;
  margin: 0 0 24px;
  font-family: Inter;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.Shape2 {
  position: relative;
  width: 100vw;
  height: 608px;
  flex-grow: 0;
  margin: 50px 0;
  padding: 24px 40px 0;
  background-color: #d3352c;
}
.Shape2PhoneImage {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.Shape2GPlayImage {
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.v-input__control {
  min-height: 10px !important;
}
@keyframes slide {
  from {
    right: 100px;
  }
  to {
    right: 0px;
  }
}
@keyframes pendana {
  from {
    left: 100px;
  }
  to {
    left: 0px;
  }
}
</style>
